import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-138d4634"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-edit"
}
const _hoisted_2 = { class: "label-update" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "label-update" }, "Expert level", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-check fas green" }, null, -1))
const _hoisted_5 = { class: "image-body" }
const _hoisted_6 = {
  key: 0,
  class: "data-image first-left d-flex"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-auto" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "text-image"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 2,
  class: "image",
  src: "/img/not_found.jpg",
  alt: "Not Image"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: image?.id || 0,
        class: _normalizeClass(_ctx.images.length === 1 ? 'image-list-one' : 'image-list')
      }, [
        (_ctx.edit && _ctx.functionBtn && image?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.$t("magnitude.level")), 1),
                _createVNode(_component_el_tag, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(image.level ? image.level : "-"), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", null, [
                _hoisted_3,
                _createVNode(_component_el_select, {
                  class: "select-wrapper",
                  onChange: ($event: any) => (_ctx.activeBtnSaveMap[index] = false),
                  modelValue: image.expertLevel,
                  "onUpdate:modelValue": ($event: any) => ((image.expertLevel) = $event),
                  "allow-create": "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: option.label,
                        label: option.label,
                        value: option.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
              ]),
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: _ctx.$t('btn.save'),
                placement: "bottom-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    onClick: ($event: any) => (_ctx.updateImage(image, index)),
                    disabled: _ctx.activeBtnSaveMap[index],
                    circle: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ]),
                _: 2
              }, 1032, ["content"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (image && _ctx.paramsVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                (image?.time && image?.date)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createTextVNode(_toDisplayString(image.title
                ? image.title
                : _ctx.isAppDemo
                ? image.samplingPoint?.id
                : image.samplingPoint?.name) + " - " + _toDisplayString(_ctx.formatDate(image)) + " ", 1),
                      (image.camera && _ctx.TARGET_POINTS.includes(image.samplingPoint?.code || ''))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, " | " + _toDisplayString(image.camera), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterEstimations(image.imageEstimation as EstimationWithTmoa[]), (estimation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: estimation.id,
                    class: "text-image"
                  }, [
                    (estimation?.parameter?.code)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (estimation.parameter.code.includes('TMOA'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(estimation.parameter.name) + ": " + _toDisplayString(estimation.tmoaName || "-"), 1)
                              ], 64))
                            : (estimation?.parameter.code === 'ALT')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(estimation.parameter.name) + ": " + _toDisplayString(estimation.value === 1
                    ? "Anomalía detectada"
                    : estimation.value === 0
                    ? "Sin anomalía"
                    : "-"), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.getNameParameter(estimation.parameter)) + ": " + _toDisplayString(estimation.value === undefined
                    ? "-"
                    : isNaN(Number(estimation.value))
                    ? estimation.value
                    : _ctx.$n(Number(estimation.value), "default")) + " " + _toDisplayString(_ctx.getUnitParameter(estimation.parameter)) + " ", 1),
                                  _createElementVNode("span", null, _toDisplayString(estimation?.trend !== undefined && estimation?.trend !== null
                      ? _ctx.$t("info.trend." + estimation.trend)
                      : "-"), 1)
                                ], 64))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.getNameParameter(estimation?.parameter)) + ": - ", 1)
                        ], 64))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (image && image?.fileName && _ctx.src[image?.fileName])
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "image",
              src: _ctx.src[image.fileName],
              alt: image.fileName
            }, null, 8, _hoisted_11))
          : _createCommentVNode("", true),
        (!image || !image?.fileName || !_ctx.src[image?.fileName])
          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}